// Single source of truth for the app version.
// Updated automatically by the CI/CD version-bump workflow.
export const APP_VERSION = "1.26.8";
